module.exports = __webpack_public_path__ + "media/applicants/icon-bgcheck@2x-0f614987.png";